export const THEMES = [
  { id: 'white', bg: 'bg-white', text: 'text-gray-600', activeBg: 'bg-primary-50', activeText: 'text-primary-600' },
  { id: 'teal', bg: 'bg-[#1782a2]', text: 'text-white/80 hover:text-white hover:bg-white/10', activeBg: 'bg-white/20', activeText: 'text-white' },
  { id: 'navy', bg: 'bg-[#1b263b]', text: 'text-white/80 hover:text-white hover:bg-white/10', activeBg: 'bg-white/20', activeText: 'text-white' },
  { id: 'green', bg: 'bg-[#027b76]', text: 'text-white/80 hover:text-white hover:bg-white/10', activeBg: 'bg-white/20', activeText: 'text-white' },
  { id: 'pink', bg: 'bg-gradient-to-br from-rose-500 to-orange-400', text: 'text-white/80 hover:text-white hover:bg-white/10', activeBg: 'bg-white/20', activeText: 'text-white' }
];

export const SidebarThemeSelector = ({ current, onChange }: { current: string; onChange: (id: string) => void }) => (
  <div className="flex gap-2 p-4 justify-center border-t border-gray-200/20">
    {THEMES.map(t => (
      <button key={t.id} onClick={() => onChange(t.id)} title={t.id}
        className={`w-6 h-6 rounded-full border-2 ${current === t.id ? 'border-gray-900 scale-110' : 'border-transparent'} ${t.bg}`}
      />
    ))}
  </div>
);
